function FounderSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/20 mb-6">
            <i className="ri-user-heart-line text-emerald-600"></i>
            <span className="text-sm text-emerald-700 font-semibold whitespace-nowrap">代表メッセージ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            実体験に基づく、<br className="md:hidden" />本物のサポート
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 bg-gradient-to-br from-slate-50 to-white rounded-3xl p-10 shadow-xl border border-slate-100">
          {/* Portrait */}
          <div className="flex-shrink-0">
            <div className="relative w-48 h-48 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/11fbae8306ba7f8f6182fe2cb1c771c5.jpg"
                alt="代表者プロフィール写真"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 ring-2 ring-emerald-500/20 rounded-2xl"></div>
            </div>
          </div>

          {/* Message Content */}
          <div className="flex-1 text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/20 mb-6">
              <i className="ri-home-heart-line text-emerald-600"></i>
              <span className="text-sm text-emerald-700 font-semibold whitespace-nowrap">現役東京ホスト</span>
            </div>

            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              理論ではなく、実践。<br />
              経験に基づく確かなサポート。
            </h3>

            <p className="text-xl text-slate-700 leading-relaxed mb-6">
              私自身が東京で民泊を運営し、試行錯誤を重ねてきました。申請の複雑さ、価格設定の難しさ、ゲスト対応の大変さ——すべて経験しています。
            </p>

            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              だからこそ、オーナー様の不安や悩みに寄り添い、実践的で効果的なサポートを提供できます。これは机上の理論ではなく、現場で培った生きた知識です。
            </p>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
              <div className="flex items-center gap-2 text-slate-700">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">簡易宿所営業許可取得済み</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">現役で運営中</span>
              </div>
              <div className="flex items-center gap-2 text-slate-700">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">3年以上の実績</span>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Message */}
        <div className="mt-12 text-center max-w-3xl mx-auto">
          <p className="text-lg text-slate-600 leading-relaxed">
            「民泊運営は、正しい知識と適切なサポートがあれば、確実に成功できるビジネスです。あなたの物件の可能性を、一緒に最大化しましょう。」
          </p>
          <div className="mt-6 text-right">
            <div className="inline-block">
              <div className="font-semibold text-slate-900 text-lg">Magome Kominka 代表</div>
              <div className="text-sm text-slate-500 mt-1">東京・大田区</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FounderSection;